import db from '@/services/db'
import store from '@/store'
import eventBus from '@/helpers/event-bus'

let $ = window.$

const addWidget = (gsOptions, type) => {
  const storeData = {
    currentTab: store.state.currentTab,
    currentSubTab: store.state.currentSubTab,
  }
  let data = {
    gsOptions,
    layout: 'b-card',
    tab: storeData.currentTab,
  }

  if (!type) data.template = ''
  if (type) data.type = type
  if (storeData.currentSubTab) data.subtab = storeData.currentSubTab

  store.commit('addProcess', {
    process: 'addWidget',
    message: 'Creating',
  })

  db.widgets.create(data, key => {
    store.commit('addedWidgetKey', key)
    store.commit('deleteProcess', 'addWidget')
    store.commit('toolsPanel_setItem', {
      id: 'editWidget',
      payload: {
        key,
      },
    })
  })
}

export default {
  grid: null,
  init(gridInstance, canUpdate) {

    const grid = GridStack.init({
      handle: '.grid-stack-item__move',
      verticalMargin: 30,
      column: 24,
      minWidth: 900,
      cellHeight: 30,
      acceptWidgets: '.grid-stack-item',
    })

    this.grid = grid
    if (!grid) return

    function addedHandler(e, items) {
      const temporary = items.filter(i => {
        return i._temporary && i.el
      })

      temporary.forEach(widget => {
        const { el } = widget
        const event = el.getAttribute('data-event-name')
        const eventData = el.getAttribute('data-event-data')
        const type = el.getAttribute('type')

        if (event) {
          eventBus.$emit(event, {
            data: eventData,
            gsOptions: {
              x: widget.x,
              y: widget.y,
              w: widget.width,
              h: widget.height,
            },
          })
        } else {
          addWidget(
            { x: widget.x, y: widget.y, w: widget.width, h: widget.height },
            type
          )
          grid.float(true)
        }
        setTimeout(() => {
          grid.removeWidget(widget.el)
        }, 0)
      })
    }

    grid.off('added', addedHandler)
    grid.on('added', addedHandler)

    if (!canUpdate || $(grid).find('.grid-stack-item._inherited').length) return

    function changeHandler(event, items) {
      if (!canUpdate || $(grid).find('.grid-stack-item._inherited').length) return

      if (!items) return

      const savedWidgets = items.filter(i => {
        return !i._temporary && i.el
      })

      for (let item of savedWidgets) {
        let widgetId = item.el.getAttribute('widget-id')

        for (let widgetKey in gridInstance.widgetsReady) {
          if (widgetKey !== widgetId) return

          let newCoords = {
            x: item.x,
            y: item.y,
            w: item.width,
            h: item.height,
          }

          db.getRef('widgets')
            .child(widgetId + '/gsOptions')
            .update(newCoords, function(err) {
              if (err) throw err
            })
        }
      }
    }

    grid.off('change', changeHandler)
    grid.on('change', changeHandler)
  },
  disableStatic() {
    const { grid } = this
    if (!grid) return
    grid.float(false)
    grid.setStatic(false)
  },
  move(item, options) {
    this.grid.move(item, options.x, options.y)
  },
  update() {
    let el = $('.grid-stack-item:not(.ui-draggable)')
    let instance = this.grid
    if (instance) {
      let coords = [
        $(el).data('gs-x'),
        $(el).data('gs-y'),
        $(el).data('gs-width'),
        $(el).data('gs-height'),
      ]

      instance.addWidget(el, ...coords, true)
    }
  },
  destroy() {
    if (this.grid) this.grid.destroy()
    this.grid = null
  },
  destroyOne(el) {
    let instance = this.grid
    instance.removeWidget(el)
  },
  freeze(statement, el) {
    let grid = $(el).data('gridstack')
    if (!grid) return
    if (statement) {
      grid.movable('.grid-stack-item', false)
      grid.resizable('.grid-stack-item', false)
    } else {
      grid.movable('.grid-stack-item', true)
      grid.resizable('.grid-stack-item', true)
    }
  },
}
